<template>
  <div>
    <a-modal :visible="modalVisible" :closable="false" :width="800" @cancel="closeModal">
      <a-table :width="2000" :columns="columns" :data-source="taskList">
        <span slot="task_name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.task_name">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.task_name }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="taskStatus[record.status]" :color="taskStatus[record.status].color">{{ taskStatus[record.status].label }}</a-tag>
        </span>
        <span slot="is_over_time" slot-scope="text, record">
          <a-tag v-if="record.is_over_time == 1" color="red">{{ '是' }}</a-tag>
          <a-tag v-if="record.is_over_time == 0" color="green">{{ '否' }}</a-tag>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>

<script>
import { taskStatus } from '@/utils/dictionary';
export default {
  props: {
    taskList: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      modalVisible: false,
      taskStatus,
      columns: [
        {
          title: '任务id',
          dataIndex: 'task_id',
          width: '10%',
          key: 'task_id',
          scopedSlots: { customRender: 'task_id' }
        },
        {
          title: '标题',
          dataIndex: 'task_name',
          width: '40%',
          key: 'task_name',
          scopedSlots: { customRender: 'task_name' }
        },
        {
          title: '任务点',
          dataIndex: 'point',
          width: '10%',
          key: 'point',
          scopedSlots: { customRender: 'point' }
        },
        {
          title: '开发完成时间',
          dataIndex: 'dev_end_time',
          width: '15%',
          key: 'dev_end_time',
          scopedSlots: { customRender: 'dev_end_time' }
        },
        {
          title: '预计开发完成时间',
          dataIndex: 'pre_end_time',
          width: '15%',
          key: 'pre_end_time',
          scopedSlots: { customRender: 'pre_end_time' }
        }
      ]
    };
  },
  computed: {
    link() {
      return record => {
        return record && record.project_id && record.task_id ? this.$router.resolve({ name: 'page:project:task:detail', query: { taskId: record.task_id }, params: { project_id: record.project_id }}).href : '';
      };
    }
  },
  methods: {
    // 获取任务列表
    getTodoList() {
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
    open() {
      this.modalVisible = true;
    }
  }
};
</script>

<style scoped>
.purple {
  background-color: rgba(128, 50, 150, 0.5);
  color: white;
  border-radius: 6px;
}

.orange {
  background-color: orange;
  color: white;
  border-radius: 6px;
}

.purple-orange {
  background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
  color: white;
  border-radius: 6px;
}
</style>
